export const automationRulesConstants = {
    AUTOMATION_RULES_LOADING: 'AUTOMATION_RULES_LOADING',
    AUTOMATION_RULES_LOADING_ERROR: 'AUTOMATION_RULES_LOADING_ERROR',
    AUTOMATION_RULES_SET_IS_LOADING: 'AUTOMATION_RULES_SET_IS_LOADING',
    AUTOMATION_RULES_STOP_LOADING: 'AUTOMATION_RULES_STOP_LOADING',
    AUTOMATION_RULES_UPDATE_ORDER_BY: 'AUTOMATION_RULES_UPDATE_ORDER_BY',
    AUTOMATION_RULES_UPDATE_SORT_BY: 'AUTOMATION_RULES_UPDATE_SORT_BY',
    AUTOMATION_RULES_UPDATE_RULE: 'AUTOMATION_RULES_UPDATE_RULE',
    AUTOMATION_RULES_UPDATE_RULE_STATUS: 'AUTOMATION_RULES_UPDATE_RULE_STATUS',
    AUTOMATION_RULES_UPDATE_SORT_COLUMNS: 'AUTOMATION_RULES_UPDATE_SORT_COLUMNS',
    AUTOMATION_RULES_INFINITY_SCROLL: 'AUTOMATION_RULES_INFINITY_SCROLL',
    AUTOMATION_RULES_DELETE_RULE: 'AUTOMATION_RULES_DELETE_RULE',
    AUTOMATION_RULES_ADD_RULE: 'AUTOMATION_RULES_ADD_RULE',
    AUTOMATION_RULES_FIND_RULE: 'AUTOMATION_RULES_FIND_RULE',
    AUTOMATION_RULES_CLOSE_FORM: 'AUTOMATION_RULES_CLOSE_FORM'
};
